//#region  Start Scope: imports
import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import { dateDiff } from '../../../../utils/consts/months';
import FlightPath from '../flightPath';
import {
  getDayDiff,
  returnDayWithMonthName,
  returnShamsiDayWithMonthName,
  returnWeeekDay,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';
import { Tooltip } from '../../../../component';
import { Border } from '../../../../domain/flight-booking/flightInvoice/border/border';
import { CircleIcon } from '~svg/index';
import momentjs from 'moment-jalaali';
import '../flightInformation/flightInformation.scss';

//#endregion
class FlightRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreFlag: [],
      take: 20,
      selectedRow: -1,
      showMore: false,
    };
  }

  //#region  Start Scope: Functions
  //show day count difference for aarive time
  makeArriveMessage = (dayDiff) => {
    let {
      language: { name },
      intl,
    } = this.props;
    return `${intl.formatMessage({
      id: 'booking.arrivein',
      defaultMessage: 'booking.arrivein',
    })} ${Math.abs(dayDiff)} ${
      dayDiff > 0
        ? intl.formatMessage({
            id: 'booking.nextdays',
            defaultMessage: 'booking.nextdays',
          })
        : intl.formatMessage({
            id: 'booking.previousedays',
            defaultMessage: 'booking.previousedays',
          })
    }${dayDiff > 1 && name === 'en' ? 's' : ''}`;
  };

  //#endregion
  //#region  Render
  //show flight airport and flight dateTime informations and tooltip for airport
  renderCityInfo = (item, index) => {
    const { name, direction } = this.props.language,
      flightType = this.props.flightType;
    // compare dates if arrival date time is in next days or previous day because of timezone
    let dayDiff = getDayDiff(
      item.flights[0].departureDateTime,
      item.flights[item.flights.length - 1].arrivalDateTime,
    );
    if (item) {
      return (
        <div
          className={`d-flex flex-column w-100 ${
            direction == 'rtl' ? 'pl-4' : 'pr-4 '
          }`}
        >
          <div
            className={`d-flex align-items-center justify-content-center 
          ${direction == 'rtl' ? 'pl-3 pl-sm-4' : 'pr-3 pr-sm-4'}
          `}
          >
            <div className="px-2 px-md-3 d-flex justify-content-center">
              <div className="font-weight-bold d-flex flex-column justify-content-center">
                <div
                  className={`d-flex flex-column font-small font-xs-msmall  font-md-xlarge align-items-center text-dark  ${
                    flightType === 'roundtrip' && index !== 0
                      ? ''
                      : 'font-weight-bold'
                  }`}
                >
                  {/* departure  time */}
                  {item.flights[0].departureDateTime
                    .split('T')[1]
                    .substring(0, 5)}
                </div>
                <div className="d-flex flex-column align-items-center text-primary-dark pt-sm-1">
                  <div className="font-smaller font-sm-small  text-center text-gray">
                    {item.flights[0].departureAirport.cityName[name]}
                  </div>
                </div>
              </div>
            </div>
            {/* show airplane image to show origin and destination */}
            <div className="w-50 justify-content-center">
              <div className="d-flex w-100">
                <div className="d-flex justify-content-center position-relative w-100">
                  <div className="d-flex w-100 flex-column">
                    <div className="d-none d-md-flex w-100 ">
                      <FlightPath direction={direction} />
                    </div>
                    <div className="d-flex d-md-none align-items-center flex-column  p-0">
                      <span className="text-secondary font-weight-bold font-smaller font-sm-small  ">
                        <FormattedMessage id={'booking.nonstop'} />
                      </span>
                      <div className="d-flex  text-nowrap px-2 px-sm-4  font-xsmall font-sm-small py-1 justify-content-center rounded-pill  align-items-center border  justify-content-center  ">
                        <FormattedMessage id="booking.duration" />
                        <span className="px-xs-1 px-sm-1">
                          {item.flights[0].flightDuration}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex  justify-content-center align-items-center py-0 px-xs-1 px-sm-2  m-0 ">
                      <span
                        className={`p-1 font-weight-bold font-xsmall  font-sm-small   ${
                          item.isCharter ? 'text-danger' : 'text-info'
                        }  `}
                      >
                        <FormattedMessage
                          id={`booking.${
                            item.isCharter ? 'charter' : 'systemic'
                          }`}
                          defaultMessage={`booking.${
                            item.isCharter ? 'charter' : 'systemic'
                          }`}
                        />
                      </span>
                      <div className="font-weight-normal text-third  d-flex  justify-content-center">
                        <span
                          className={`  font-xsmall font-sm-small text-nowrap  py-1 ${
                            item.flights[0].resBookDesigCabinName['en'] ===
                            'Economy'
                              ? 'text-third  '
                              : 'text-warning'
                          } font-weight-bold `}
                        >
                          {` - ${item.flights[0].resBookDesigCabinName[name]}`}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-center position-absolute w-100"
                    style={{ top: '-5px', height: 32 }}
                  >
                    {/* show dot for each stop count */}
                    {this.renderCircleStopCount(item, index)}
                  </div>
                </div>
              </div>
            </div>

            <div className="font-weight-bold d-flex flex-column justify-content-center px-2 px-md-3">
              <div className="d-flex font-xlarge font-weight-normal align-items-center justify-content-center text-dark">
                <div
                  className={`d-flex justify-content-center font-small font-xs-msmall   font-md-xlarge  ${
                    dayDiff !== 0 ? 'col-11 px-0 mx-0 ' : 'w-100'
                  } `}
                >
                  {item.flights[item.flights.length - 1].arrivalDateTime
                    .split('T')[1]
                    .substring(0, 5)}
                </div>
                {dayDiff !== 0 && (
                  <div className="col-1 justify-content-end  d-flex">
                    {/* show tooltip for show if arrive time is on next days */}
                    <Tooltip
                      position={'top'}
                      content={this.makeArriveMessage(dayDiff)}
                      direction={direction}
                      backgroundColor="warning"
                      textColor="dark"
                    >
                      <div
                        className="d-flex px-1  text-captalize text-secondary align-items-center font-smaller font-weight-bold justify-content-center cursor-pointer"
                        style={{ direction: 'ltr' }}
                      >
                        {/* like +1 next day or 1 previous day */}
                        {dayDiff > 0 ? `+${dayDiff}` : dayDiff}
                      </div>
                    </Tooltip>
                  </div>
                )}
              </div>

              <div className="d-flex flex-row justify-content-center align-items-center font-small font-weight-bold text-primary-dark text-center  ">
                <div className="d-flex font-smaller font-sm-small p-0 pt-sm-1 justify-content-center text-gray">
                  {
                    //city of arrival airport
                    item.flights[item.flights.length - 1].arrivalAirport
                      .cityName[name]
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else return '';
  };

  /* show dot for each stop count */
  renderCircleStopCount(flight, indx) {
    if (flight) {
      let { name } = this.props.language,
        arr = [];

      for (let i = 0; i < flight.StopCount; i++) {
        arr[i] = i;
      }

      return arr.map((item, index) => (
        <div
          key={`frag-${ind}-${indx}-${index}`}
          className="d-flex flex-column align-items-center"
          style={{ width: `${200 / (flight.StopCount + 1)}px` }}
        >
          <Tooltip
            position={'top'}
            content={`${this.props.intl.formatMessage({
              id: 'booking.stopin',
              defaultMessage: 'booking.stopin',
            })} ${flight.flights[index].arrivalAirport.name[name]}${
              flight.flights.length > 1 &&
              index + 1 <= flight.flights.length &&
              flight.flights[index + 1] &&
              ` (${dateDiff(
                flight.flights[index + 1].departureDateTime,
                flight.flights[index].arrivalDateTime,
              )}`
            })`}
            direction={direction}
            backgroundColor="warning"
            textColor="dark"
          >
            <div className="d-flex  font-smaller pointer text-secondary">
              {flight.flights[index].arrivalAirport.code}
            </div>
          </Tooltip>
          <div
            key={`stop-${indx}-${index}-${flight.flights[index].arrivalAirport.name[name]}`}
            className="py-0 "
          >
            <CircleIcon size={12} color="#00798c" />
          </div>
        </div>
      ));
    }
  }

  renderAirplaneIcon(flight, ind, type) {
    let {
      language: { name, direction },
      intl,
    } = this.props;
    let allAirlines = [
      ...new Set(flight.map((t) => [t.operatingAirline])),
    ].reduce((a, b) => {
      return a.concat(b);
    });
    let operatingAirline = [
      ...new Map(allAirlines.map((item) => [item.code, item])).values(),
    ];

    if (flight && flight.length > 0 && operatingAirline.length) {
      return (
        <div
          style={{}}
          className="d-flex flex-column align-items-center justify-content-center "
        >
          <div className="d-flex  flex-row align-items-center justify-content-center text-nowrap position-relative p-2 p-sm-0 px-md-2">
            {operatingAirline.map((item, index) => {
              let position = -30 * index;
              return (
                <div className="d-flex" key={`route-${index}`}>
                  <img
                    key={`img-${index}`}
                    style={{
                      width: '2.5rem',
                      zIndex: operatingAirline.length - index,
                      marginRight:
                        direction === 'ltr'
                          ? operatingAirline.length === 1 || index === 0
                            ? '0px'
                            : `${position}px`
                          : '0px',
                      marginLeft:
                        direction === 'rtl'
                          ? operatingAirline.length === 1 || index === 0
                            ? '0px'
                            : `${position}px`
                          : '0px',
                    }}
                    title={item.name[name]}
                    className={`d-flex justify-content-center rounded-circle bg-white border border-1 p-1 ${
                      index === 0 ? '' : 'position-absolute'
                    }
                   
                   `}
                    src={returnAirlineLogos(item.code)}
                    alt="airlines"
                  />
                </div>
              );
            })}
          </div>

          {operatingAirline.length === 1 ? (
            <div className="d-flex  justify-content-center text-nowrap mt-2 w-100 align-items-start font-smaller font-sm-msmall text-center font-weight-bold text-third  h-25">
              {operatingAirline[0].name[name]}
            </div>
          ) : (
            <div className="d-flex text-nowrap justify-content-center mt-2 w-100 align-items-start text-third  font-xsmall text-center font-weight-bold position-relative h-25">
              {intl.formatMessage({
                id: 'booking.multiairline',
              })}
            </div>
          )}
        </div>
      );
    }
  }

  render() {
    let { flightList, containerClass, containerStyle } = this.props;
    let { name, direction } = this.props.language;

    return (
      <div className="w-100 p-0 d-flex m-0 py-0   card-body  border-none position-relative">
        <div
          id="optionList"
          className={`w-100  d-flex flex-column  py-0 position-relative ${containerClass}`}
          style={containerStyle}
        >
          {flightList.itineraries.map((flight, indx) => {
            return (
              <React.Fragment key={`flight${indx}`}>
                <div className="d-flex w-100 pb-0 h-100 mb-0 ">
                  <div
                    className={` d-flex flex-column  bg-white w-100 px-2 px-sm-3 px-md-5 px-lg-2  m-0
                  ${
                    indx == 0
                      ? 'py-2 py-sm-3 pt-md-5 pt-lg-4'
                      : 'pt-2 pb-3 pb-md-0'
                  }  
                  
                    `}
                  >
                    <div className="d-flex align-items-center px-lg-3  pb-2 pb-sm-3 pb-md-4 ">
                      <span
                        className={`font-smaller font-sm-msmall d-flex justify-content-start align-items-center text-primary`}
                      >
                        <img
                          style={{ width: '1.5rem' }}
                          alt=""
                          src={require(`../../../../content/images/icon/${
                            indx === 0
                              ? direction === 'rtl'
                                ? 'destination.png'
                                : 'origin.png'
                              : direction === 'rtl'
                              ? 'origin.png'
                              : 'destination.png'
                          }`)}
                          className=""
                        />
                        <span className="px-1 text-nowrap">
                          <FormattedMessage
                            id={
                              indx !== 0
                                ? 'booking.returnflight'
                                : 'booking.departureflight'
                            }
                          />
                        </span>
                      </span>
                      <span
                        className={`font-smaller font-sm-msmall px-lg-2 justify-content-center d-flex text-secondary`}
                      >
                        {name === 'fa'
                          ? `${returnWeeekDay(
                              flight.flights[0].departureDateTime.split('T')[0],
                              name,
                              false,
                            )} ${returnShamsiDayWithMonthName(
                              momentjs(
                                flight.flights[0].departureDateTime.split(
                                  'T',
                                )[0],
                                'YYYY-M-D',
                              ).format('jYYYY-jMM-jDD'),
                              name,
                            )}
                            ، ${returnDayWithMonthName(
                              flight.flights[0].departureDateTime.split('T')[0],
                              name,
                            )}`
                          : `${returnWeeekDay(
                              flight.flights[0].departureDateTime.split('T')[0],
                              name,
                              false,
                            )}   ${returnDayWithMonthName(
                              flight.flights[0].departureDateTime.split('T')[0],
                              name,
                            )}`}
                      </span>
                    </div>
                    <div className="d-flex w-100 flex-column justify-content-around">
                      <div className="d-flex w-100 justify-content-center  align-items-center px-2 px-sm-3 px-xl-4">
                        <div className="d-flex flex-column p-0 font-large">
                          {/* show flight for origin and destination */}

                          {this.renderAirplaneIcon(flight.flights, indx)}
                        </div>
                        {/* show all airport info like name and time */}
                        {this.renderCityInfo(flight, indx)}
                        {/* show remain seat and flight duration */}
                      </div>
                    </div>
                  </div>
                </div>
                {indx !== flightList.itineraries.length - 1 ? (
                  <>
                    <Border />
                  </>
                ) : (
                  <></>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }
  //#endregion
}
function mapStateToProps(state) {
  return {
    language: state.language,
    user: state.user,
  };
}
//#region propTypes and default props
FlightRoute.propTypes = {
  parsedQueryStr: propTypes.object,
  flightType: propTypes.string,
  flightList: propTypes.object,
  totalPassenger: propTypes.number,
  airLineLst: propTypes.array,
};
FlightRoute.defaultProps = {
  parsedQueryStr: {},
  flightType: 'oneway',
  flightList: {},
  totalPassenger: 1,
  airLineLst: [],
};
//#endregion
export default injectIntl(connect(mapStateToProps)(withRouter(FlightRoute)));
